// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__wdS_n","heading-row":"Card_heading-row__FW747","heading":"Card_heading__qbPeq","close":"Card_close__z3KNZ","icon":"Card_icon__81nul"};